import { Injectable, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { OpenBetTheme } from "app/app.component";
import { PrimeNG } from "primeng/config";
import { switchMap } from "rxjs";
@Injectable({
    providedIn: "root",
})
export class PrimengService implements OnInit {
    constructor(
        private primengConfig: PrimeNG,
        private translateService: TranslateService,
    ) {}

    ngOnInit() {}

    initPrime() {
        this.primengConfig.theme.set({
            preset: OpenBetTheme,
            options: {
                prefix: "p",
                darkModeSelector: ".dark",
                cssLayer: false,
            },
        });
        this.primengConfig.ripple.set(true);

        this.primengConfig.zIndex = {
            modal: 1100, // dialog, sidebar
            overlay: 1000, // dropdown, overlaypanel
            menu: 1000, // overlay menus
            tooltip: 1100, // tooltip
        };
        this.translateService
            .stream([
                "PRIMENG.MATCH_ALL",
                "PRIMENG.MATCH_ANY",
                "PRIMENG.ADD_RULE",
                "PRIMENG.REMOVE_RULE",
                "PRIMENG.CLEAR",
                "PRIMENG.APPLY",
                "PRIMENG.SELECTION_MESSAGE",
                "PRIMENG.EMPTY_SELECTION_MESSAGE",
            ])
            .pipe(
                switchMap((translations) => {
                    this.primengConfig.setTranslation({
                        matchAll: translations["PRIMENG.MATCH_ALL"],
                        matchAny: translations["PRIMENG.MATCH_ANY"],
                        addRule: translations["PRIMENG.ADD_RULE"],
                        removeRule: translations["PRIMENG.REMOVE_RULE"],
                        clear: translations["PRIMENG.CLEAR"],
                        apply: translations["PRIMENG.APPLY"],
                        selectionMessage:
                            translations["PRIMENG.SELECTION_MESSAGE"],
                        emptySelectionMessage:
                            translations["PRIMENG.EMPTY_SELECTION_MESSAGE"],
                    });
                    return [];
                }),
            )
            .subscribe();
    }
}
